<template>
  <div
    class="contact-wrapper"
    :class="{'wrapper-moved': hovered}"
    @mouseleave="removeHover()"
  >
    <div
      class="sky"
      :class="{moved: hovered}"
    >
      <div class="info-wrapper">
        <div
          class="info"
        >
          <p>Mail: splendor.wrld@gmail.com</p>
          <p>Adres: ul. JANA KAZIMIERZA 57/46</p>
          <p>01-267 WARSZAWA</p>
          <p>MAZOWIECKIE</p>
          <div class="icons-wrapper">
            <div class="social-icon">
              <a href="https://www.instagram.com/splendorwrld/"><b-icon-instagram /></a>
            </div>
            <div class="social-icon">
              <a href="https://www.facebook.com/splendorwrld"><b-icon-facebook /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="sun"
      class="sun"
    >
      <img
        src="@/assets/logo_yellow.svg"
        alt=""
      >
    </div>
    <div
      v-if="renderIconStart"
      class="icon"
      @mouseenter="handleHover()"
    >
      <BIconArrowDown />
    </div>
    <div
      v-if="renderIconBack"
      class="icon-back"
      @mouseenter="removeHover()"
    >
      <BIconArrowUp />
    </div>
  </div>
</template>

<script>

export default {
  name: 'Contact',
  data () {
    return {
      hovered: false,
      renderIconStart: true,
      renderIconBack: false
    }
  },
  methods: {
    handleHover () {
      this.hovered = true
      this.handleIconHover()
      const logo = document.getElementById('mainLogo')
      logo.style.display = 'none'
      const header = document.getElementById('mainHeader')
      header.style.display = 'none'
      const sun = document.getElementById('sun')
      sun.style.display = 'block'
    },
    removeHover () {
      this.hovered = false
      this.handleIconBack()
      const logo = document.getElementById('mainLogo')
      logo.style.display = 'block'
      const header = document.getElementById('mainHeader')
      header.style.display = 'block'
      const sun = document.getElementById('sun')
      sun.style.display = 'none'
    },
    showIconStart () {
      this.renderIconStart = true
    },
    showIconBack () {
      this.renderIconBack = true
    },
    handleIconHover () {
      this.renderIconStart = false
      setTimeout(() => { this.showIconBack() }, 500)
    },
    handleIconBack () {
      this.renderIconBack = false
      setTimeout(() => { this.showIconStart() }, 500)
    }
  }

}
</script>

<style scoped lang="scss">
.info {
  padding-top: 150px;
  color: #000000;
  letter-spacing: 2px;
}
.icons-wrapper {
  display: inline-block;
}
.social-icon {
  font-size: 3rem;
  margin-top: 10px;
}
.social-icon a {
  color: inherit;
}
.icon {
  display: none;
}
.icon-back {
  display: none;
}
.sun {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 400px;
  display: none;
}

@media (min-width: 992px) {
  .contact-wrapper {
    height: 100vh;
    width: 100vw;
    cursor: pointer;
    overflow: hidden;
    transition-delay: 0.5s;
  }
  .contact-wrapper:hover {
    transition-delay: 0s;
  }
  .wrapper-moved {
    width: 150%;
    transform: translateX(-25%);
  }
  .sky {
    width: 100%;
    height: 100%;
    transform: translateY(-150vh);
    transition-duration: 0.5s;
    transition-timing-function: ease-out;
    background-image: linear-gradient(rgb(56, 122, 197), lightblue);
  }
  .moved {
    transform: translateY(0);
  }
  .icon {
    position: relative;
    bottom: 60%;
    left: -20%;
    font-size: 100px;
    height: 100px;
    color: #000000;
    opacity: 1;
    transition: color;
    transition-delay: 1s;
    display: block;
  }
  .icon-back {
    position: relative;
    bottom: 37%;
    font-size: 100px;
    height: 100px;
    color: yellow;
    opacity: 1;
    transition: color;
    transition-delay: 1s;
    display: block;
  }
  .info-wrapper {
    display: inline-block;
  }
  .info {
    padding-top: 20vh;
    margin-top: 0;
    font-size: 1.3rem;
    letter-spacing: 2px;
    color: yellow;
    text-align: left;
    width: 100%;
  }
  .icons-wrapper {
    // width: 100%;
    margin-top: 20px;
    display: inline-block;
  }
  .social-icon {
    width: 50px;
    margin-left: 30px;
    margin-right: 30px;
    float: left;
  }
  .sun img {
  width: 550px;
}
}
</style>
